/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MondayStatusChangeProjectMilestoneRequest,
  OK,
} from '../models/index';
import {
    MondayStatusChangeProjectMilestoneRequestFromJSON,
    MondayStatusChangeProjectMilestoneRequestToJSON,
    OKFromJSON,
    OKToJSON,
} from '../models/index';

export interface WebhookMondayStatusChangeProjectMilestoneRequest {
    mondayStatusChangeProjectMilestoneRequest: MondayStatusChangeProjectMilestoneRequest;
}

/**
 * 
 */
export class MondayApi extends runtime.BaseAPI {

    /**
     * Used as a target for monday.com custom application actions, will produce info level logs containing full payload.
     * Monday.com debug action
     */
    async webhookMondayDebugActionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OK>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhook/monday/debug/action`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OKFromJSON(jsonValue));
    }

    /**
     * Used as a target for monday.com custom application actions, will produce info level logs containing full payload.
     * Monday.com debug action
     */
    async webhookMondayDebugAction(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OK> {
        const response = await this.webhookMondayDebugActionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates Opus with Milestone status changes from a Monday.com Project Master board.  This webhook requires a column ID passed in for the Bid Number 
     * Monday.com Project Master milestone status change
     */
    async webhookMondayStatusChangeProjectMilestoneRaw(requestParameters: WebhookMondayStatusChangeProjectMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OK>> {
        if (requestParameters['mondayStatusChangeProjectMilestoneRequest'] == null) {
            throw new runtime.RequiredError(
                'mondayStatusChangeProjectMilestoneRequest',
                'Required parameter "mondayStatusChangeProjectMilestoneRequest" was null or undefined when calling webhookMondayStatusChangeProjectMilestone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhook/monday/status_change/project_milestone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MondayStatusChangeProjectMilestoneRequestToJSON(requestParameters['mondayStatusChangeProjectMilestoneRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OKFromJSON(jsonValue));
    }

    /**
     * Updates Opus with Milestone status changes from a Monday.com Project Master board.  This webhook requires a column ID passed in for the Bid Number 
     * Monday.com Project Master milestone status change
     */
    async webhookMondayStatusChangeProjectMilestone(requestParameters: WebhookMondayStatusChangeProjectMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OK> {
        const response = await this.webhookMondayStatusChangeProjectMilestoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
